<template>
    <div class="service--insurance" v-if="service.length !== 0">
        <b-row>
            <b-col offset-md="1">
                <div class="service--insurance--wrapper">
                    <b-form-group id="freetext">
                        <tiny-mce
                            :preview_mode="true"
                            :height="400"
                            :block_title="'Informazioni servizio'"
                            :initial_value="this.insurance_service.details.freetext"
                            @input="(value) => {
                                this.insurance_service.details.freetext = value
                                this.update_service()
                            }"
                        />
                    </b-form-group>
                </div>
            </b-col>
            <b-col md="4">
                <!--<b-form-group id="documents" label="Documents" label-for="documents">
                    <b-badge show variant="danger">TODO: gestione campo documents</b-badge>
                </b-form-group>-->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TinyMce from '@/components/blocks/tiny-mce'
export default {
    name: 'insurance',
    components: {
        'tiny-mce': TinyMce,
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {     
            insurance_service: this.service,
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.insurance_service
            })
        }, 
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .service--insurance
    {
        display:block !important;
    }
</style>